import axios from './axios';

export const profileService = {
  index: () => {
    return axios.get(`/api/v2/profile`);
  },
  update: (data) => {
    return axios.post(`/api/v2/profile`, data);
  }
};
